const JOB_TYPES = [
  { value: false, label: 'Regular' },
  { value: true, label: 'Flash' },
];

//A flash is billed and costed like any job, but the operations report does not count it as a pool
//finished: the pool it prepares is counted when it is shot. Flashes are sometimes booked as a job of
//their own rather than with + add flash on the pool's job, so the scheduler says which this is.
const CostBreakdownFlash = ({ value, onChange, disabled }) => {
  return (
    <div className='flex flex-col w-full gap-2 pb-3 mb-2 border-b'>
      <p className='text-sm font-semibold text-dark-blue'>Job type</p>
      <div className='flex flex-wrap items-center gap-6'>
        {JOB_TYPES.map(type => (
          <div key={type.label}>
            <input
              type='radio'
              id={`jobType-${type.label}`}
              name='jobType'
              className='mt-[-2px]'
              checked={value === type.value}
              disabled={disabled}
              onChange={() => onChange(type.value)}
            />
            <label
              htmlFor={`jobType-${type.label}`}
              className='text-dark-blue text-sm font-semibold ml-[10px]'
            >
              {type.label}
            </label>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CostBreakdownFlash;
